import { IProperty } from '../models/AndromeTV.types';
import { PageType } from '../models/Shared.types';
import { StaticPageUrls } from './ClientEvents';

export function addProperty(
  name: string,
  value: string | number | undefined,
  excluded: string[],
  properties: IProperty[]
) {
  if (!excluded.includes(name) && value) {
    properties.push({
      name,
      value: value.toString(),
    });
  }
}

export function recordingPageTypeToAnalytics(pageType: string): string | undefined {
  switch (pageType) {
    case PageType.RecordingPlanned:
      return StaticPageUrls.myStuffRecordingsPlanned;
    case PageType.RecordingRecorded:
      return StaticPageUrls.myStuffRecordingsRecorded;
    case PageType.RecordingExpired:
      return StaticPageUrls.myStuffRecordingsExpired;
  }
}
